import styled from "styled-components";
import { SlideDown } from "react-slidedown";

export const Accordion = styled.div`
  position: relative;
`;

export const AccordionItem = styled.div`
  border-top: solid 1px ${(p) => p.theme.colors.white};

  &:last-child {
    border-bottom: solid 1px ${(p) => p.theme.colors.white};
  }
`;

export const AccordionLabel = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 18px 0;
  text-transform: uppercase;
  text-align: left;
`;

export const AccordionContent = styled(SlideDown)`
  position: relative;
  will-change: transform;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.49, 0.47, 0.23, 0.92);
`;

export const AccordionContentInner = styled.div`
  padding: 5px 10px 20px 0;

  & .ScrollbarsCustom.trackYVisible {
    width: calc(100% + 10px) !important;
  }

  & .ScrollbarsCustom-TrackY {
    top: 0 !important;
    height: 100% !important;
    width: 3px !important;
    border-radius: 0 !important;
    background-color: ${(p) => p.theme.colors.white} !important;
  }

  & .ScrollbarsCustom-ThumbY {
    background-color: ${(p) => p.theme.colors.xxdkGreen} !important;
  }
`;

export const DropdownWrapper = styled.div`
  margin: 0 0 20px 0;
`;

export const AccordionList = styled.li`
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : 0)}px;
  cursor: pointer;
  list-style: none;
  font-size: 14px;
  padding: 5px 0px 5px 0px;
`;
